'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function CurrencyComponent($http, AppConstants) {
	'ngInject';

	var service = {
		fetchCurrencies: fetchCurrencies,
		fetchCurrency: fetchCurrency,
		getCurrencies: getCurrencies,
		getCurrency: getCurrency,
		createCurrency: createCurrency,
		updateCurrency: updateCurrency,
		deleteCurrency: deleteCurrency,
		setDefault: setDefault
	};

	var currencies = [];
	var currency = {};

	return service;

	function fetchCurrencies() {
		return $http.get(AppConstants.apiUrl + '/currencies').then(setCurrencies)['catch'](failedRequest);
	}

	function fetchCurrency(id) {
		return $http.get(AppConstants.apiUrl + '/currencies/' + id).then(setCurrency)['catch'](failedRequest);
	}

	function setCurrencies(res) {
		currencies = res.data.data;

		return currencies;
	}

	function setCurrency(res) {
		currency = res.data.data;

		return currency;
	}

	function getCurrencies() {
		return currencies;
	}

	function getCurrency() {
		return currency;
	}

	function createCurrency(params) {
		return $http.post(AppConstants.apiUrl + '/currencies', params).then(successRequest)['catch'](failedRequest);
	}

	function updateCurrency(id, params) {
		return $http.put(AppConstants.apiUrl + '/currencies/' + id, params).then(successRequest)['catch'](failedRequest);
	}

	function deleteCurrency(id) {
		return $http['delete'](AppConstants.apiUrl + '/currencies/' + id).then(successRequest)['catch'](failedRequest);
	}

	/** */
	function setDefault(selectedCurrency) {

		return $http.put(AppConstants.apiUrl + '/currencies/' + selectedCurrency.id + '/set-base').then(successRequest)['catch'](failedRequest);
	}

	function successRequest(response) {

		return response;
	}

	function failedRequest(requestError) {

		return requestError;
	}
}

exports['default'] = CurrencyComponent;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/components/currency/currency.service.js
 **/